import React, { Component } from "react";
import { Button, Container, Table } from "@amzn/awsui-components-react";
import TrailblazerVisual from "./TrailblazerVisual";
import { generateTableDataForMapList } from "./utils/HelperFunctions";

/**
 * This component handles the state for the selected route and
 * displaying two components: the route selector and the route visualization view.
 * The user selects a route from the route selector table to view and
 * the route visualization will appear.
 */
export default class TrailblazerVisualWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRoute: null,
            isViewButtonClicked: false
        };

        this.handleRowViewButtonClick = this.handleRowViewButtonClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    /**
     * When the search updates, go to route selector view and show the new results.
     */
    componentDidUpdate(prevProps) {
        if (this.props.trailblazerOutput !== prevProps.trailblazerOutput) {
            this.handleBackClick();
        }
    }

    /**
     * Handles navigating from the route selector to the route visualization,
     * setting the selected route to display.
     */
    handleRowViewButtonClick = (route) => {
        this.setState({
            isViewButtonClicked: true,
            selectedRoute: route
        });
    }

    /**
     * Handles back button to switch to route visualization to route selector.
     */
    handleBackClick = () => {
        this.setState({
            isViewButtonClicked: false,
            selectedRoute: null
        });
    };

    renderTable = (routes) => {
        if (!routes) {
            return (
                <Container>
                    <p>Missing routes information for Trailblazer output</p>
                </Container>
            );
        }

        const routesMetadataList = routes.map(route => route.metadata);
        const {
            tableItems: parsedMetadataList,
            columnDefinitions: metadataColumnDefinitions
        } = generateTableDataForMapList(routesMetadataList);

        const actionColumn = {
            id: "actions",
            header: "Actions",
            cell: route => (
                <Button
                    variant="normal"
                    onClick={() => this.handleRowViewButtonClick(route)}
                >
                    View
                </Button>
            )
        };
        // combine all metadata column definitions with position and name first
        const columnDefinitions = [
            ...metadataColumnDefinitions,
            actionColumn
        ];

        const columnDisplay = columnDefinitions.map(column => ({
            id: column.id,
            visible: true
        }));

        // create table items by combining hop data with parsed metadata
        const tableItems = routes.map((route, index) => ({
            id: `route-${index}`,
            ...route,
            ...parsedMetadataList[index]
        }));

        return (
            <Table
                items={tableItems}
                columnDefinitions={columnDefinitions}
                columnDisplay={columnDisplay}
                trackBy="id"
                resizableColumns
                wrapLines
            />
        );
    };

    render() {
        const { trailblazerOutput } = this.props;
        const { selectedRoute, isViewButtonClicked } = this.state;

        if (!trailblazerOutput) {
            return (
                <Container>
                    <p>Missing Trailblazer API output</p>
                </Container>
            );
        }

        if (isViewButtonClicked) {
            return (
                <TrailblazerVisual
                    selectedRoute={selectedRoute}
                    onBackClick={this.handleBackClick}
                />
            );
        }

        return (
            <div>
                {this.renderTable(trailblazerOutput.routes)}
            </div>
        );
    }
}

